import utils from "../utils";
import slider from './slider';

var productDataJson = document.querySelector('[smx-product-data]'),
	productId,
	productAttributes;

if(productDataJson){
    var productData = JSON.parse(productDataJson.getAttribute('smx-product-data'));

	productId = productData.product_id,
	productAttributes = productData.attributes;
}

window.smxProduct = {
	'currentStep' : 0,
    'productId' : productId,
    'productAttributes' : productAttributes,
	'cross' : [],
	'currency' : '€',
};

function init() {

	updateCurrentStep();
	console.log('init product');

}

function ajaxPromise(args) {

    // Funzione per utilizzare il promise

    return new Promise((resolve, reject) => {

        var loadingModal = document.querySelector('body');

        loadingModal.classList.add('is-loading');

        args.success = function (data) {
            resolve(data)
        };

        args.error = function (error) {
            reject(error)
        };

        jQuery.ajax(args);

    })
}

function updateAttributes(term,value){

	// Aggiorno l'oggetto globale
	window.smxProduct.productAttributes[term] = value

	// Triggero l'evento per cambiare l'opzione dell'attributo selezionata nel variations_form
	var attributeSelect = document.getElementById(term),
		oldSelected = attributeSelect.querySelector('[selected="selected"]'),
		newSelected = attributeSelect.querySelector('[value="' + value + '"]');

	if(oldSelected){
		oldSelected.setAttribute('selected','');
	}

	if(newSelected){
		newSelected.setAttribute('selected','selected');
	} else {
		value = oldSelected.value;
	}

	attributeSelect.value = value;
	jQuery(attributeSelect).val( value ).change();

}

function updatePrice(){

	var priceWrapper = document.getElementById('price-wrapper');

	if(priceWrapper){

		if( window.smxProduct.price.sale_status == false){
			priceWrapper.setAttribute('data-price',window.smxProduct.price.regular_price);
		} else {
			priceWrapper.setAttribute('data-price',window.smxProduct.price.sale_price);
		}

		priceWrapper.innerHTML = "";
		priceWrapper.innerHTML = window.smxProduct.price.html;

	}
}

function changeGalleryImages(term = null){

	// Funzione di cambio immagini della gallery via ajax al cambio degli attributi (e aggiornamento prezzo in steps control)

	var productGalleryWrapper = document.getElementById('product-gallery-wrapper');

	// Carico le grafiche per il retro via ajax aggiungendo il parametro side=back
	var ajaxArgs = {
		url: window.ajaxUrl,
		type: 'post',
		data : {
			action : 'smx_get_product_gallery',
			data : window.smxProduct,
			term : term,
		},
	}
	var loadGalleryPromise = ajaxPromise(ajaxArgs);

	loadGalleryPromise.then(
		function( result ) {

			// Svuoto il contenitore della gallery e lo rimepio con il risultato della chiamata
			productGalleryWrapper.innerHTML = "";
			productGalleryWrapper.innerHTML = result.html_output;

			window.smxProduct['variationId'] = result.variation_id;
			window.smxProduct['price'] = result.price;

			updatePrice();

			// Riabilito lo slider
			slider.productGalleryCarousel();

		}
	)
}

function updateCurrentStep(){

	var currentStep = document.querySelector('.single-product .single-step.active'),
		retreatButton = document.getElementById('previous-trigger'),
		forwardButton = document.querySelector('#steps-control button'),
		endText = '',
		forwardText = '';

	if(forwardButton){
		endText = forwardButton.getAttribute('data-end');
		forwardText = forwardButton.getAttribute('data-forward');
	}

	if(currentStep){

		var stepNumber = currentStep.getAttribute('data-step-number'),
			stepType = currentStep.getAttribute('data-step');

		if(stepNumber == 0){
			retreatButton.classList.add('d-none');
		} else {
			retreatButton.classList.remove('d-none');
		}

		if(stepType == 'pa_accessories'){
			forwardButton.innerHTML = '';
			forwardButton.innerHTML = endText;
			forwardButton.setAttribute('aria-label',endText);
		} else {
			forwardButton.innerHTML = '';
			forwardButton.innerHTML = forwardText;
			forwardButton.setAttribute('aria-label',forwardText);
		}

	}
	
}

window.changeVariation = function (button){

	var term = button.getAttribute('data-term'),
		value = button.getAttribute('data-value'),
		step = button.parentElement;

		var buttons = step.querySelectorAll('button');

	if(buttons.length > 0){
		utils.forEach(buttons, function (index, item) {
			item.classList.remove('active');
		})
	}
	
	button.classList.add('active');

	updateAttributes(term,value);
	changeGalleryImages(term);

}

window.changeStep = function (direction){

	var currentStepValue = window.smxProduct['currentStep'],
		currentStep = document.querySelector('.single-step[data-step-number="' + currentStepValue + '"]'),
		nextStep = document.querySelector('.single-step[data-step-number="' + (currentStepValue + 1) + '"]'),
		previousStep = document.querySelector('.single-step[data-step-number="' + (currentStepValue - 1) + '"]'),
		currentStepType = currentStep.getAttribute('data-step');

	if(direction == 'next'){

		if(currentStepType == 'pa_accessories'){
			addToCart();
		}

		if(nextStep){
			nextStep.classList.add('active');
			window.smxProduct['currentStep'] = window.smxProduct['currentStep'] + 1;
			currentStep.classList.remove('active');
		}
			

	} else if( direction == 'previous' ){
		
		if(previousStep){
			previousStep.classList.add('active');
			window.smxProduct['currentStep'] = window.smxProduct['currentStep'] - 1;
			currentStep.classList.remove('active');
		}
		
	}

	updateCurrentStep();

}

console.log(window.changeStep); 

window.addCross = function (button){

	var id = button.getAttribute('data-id'),
		price = button.getAttribute('data-price'),
		priceWrapper = document.getElementById('price-wrapper'),
		dataPrice = priceWrapper.getAttribute('data-price'),
		dataVat = priceWrapper.getAttribute('data-vat'),
		newPrice;


	if(button.parentElement.classList.contains('active')){
		button.parentElement.classList.remove('active');

		var index = window.smxProduct['cross'].indexOf(id);
		window.smxProduct['cross'].splice(index, 1);

		newPrice = (parseFloat(dataPrice) - parseFloat(price)).toFixed(2);

	} else {
	
		button.parentElement.classList.add('active');
		
		window.smxProduct['cross'].push(id);

		newPrice = (parseFloat(dataPrice) + parseFloat(price)).toFixed(2);
	}

	priceWrapper.setAttribute('data-price',newPrice);
	
	priceWrapper.innerHTML = "";
	priceWrapper.innerHTML = window.smxProduct.currency + ' ' + newPrice.replace('.',',') + ' ' + dataVat;

}

window.addInfoToggler = function (button){

	var dataLabelOpen = button.getAttribute('data-label-open'),
		dataLabelClose = button.getAttribute('data-label-close');

	if(button.parentElement.classList.contains('open')){
		button.parentElement.classList.remove('open');
		button.setAttribute('aria-label',dataLabelClose);
	} else {
		button.parentElement.classList.add('open');
		button.setAttribute('aria-label',dataLabelOpen);
	}

}

window.addCartAccessory = function (button){

	var productId = button.getAttribute('data-product-id'); 

	// Funzione per l'aggiunta al carello ajax degli accessori

	var ajaxArgs = {
		url: window.wc_add_to_cart_params.ajax_url,
		type: 'post',
		data : {
			action : 'smx_woocommerce_ajax_add_to_cart_accessory',
			productId : productId,
		},
	}
	var loadAddToCart = ajaxPromise(ajaxArgs);

	loadAddToCart.then(
		function() {

			window.location.href = window.cartUrl;

		}
	)
}

function addToCart(){

    // Funzione per l'aggiunta al carello ajax
	var ajaxArgs = {
		url: window.wc_add_to_cart_params.ajax_url,
		type: 'post',
		data : {
			action : 'smx_woocommerce_ajax_add_to_cart',
			data : window.smxProduct,
		},
	}
	var loadAddToCart = ajaxPromise(ajaxArgs);

	loadAddToCart.then(
		function() {

			window.location.href = window.cartUrl;

		}
	)

}

export default { init };